import { UnityContext } from "react-unity-webgl";
import { UNITY_REF } from "../../constants/textureConstants";
import Resizer from "react-image-file-resizer"; 
import { base64ToBlob } from "../../helpers/jsHelper";
export const textureEditUnityContext = new UnityContext(UNITY_REF);

export const getTextureThumbnail = (texture) => {
  return texture?.thumbnail;
}

function resizeImageToBlobURLViaCanvas(file, maxWidth = 300, maxHeight = 300, quality = 1) {
  return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
          const img = new Image();
          img.crossOrigin = "anonymous";  // Fix for CORS-related issues
          const byteImage = event.target.result;
          const blobData = base64ToBlob({imageString: byteImage.split(",")[1], mimeType: 'image/jpeg'});
          const imageUrl = URL.createObjectURL(blobData);
          img.src = imageUrl;

          img.onload = () => {
              let width = img.width;
              let height = img.height;

              if (width > maxWidth || height > maxHeight) {
                  const aspectRatio = width / height;
                  if (width > height) {
                      width = maxWidth;
                      height = Math.round(maxWidth / aspectRatio);
                  } else {
                      height = maxHeight;
                      width = Math.round(maxHeight * aspectRatio);
                  }
              }

              // Create Canvas
              const canvas = document.createElement("canvas");
              canvas.width = width;
              canvas.height = height;
              const ctx = canvas.getContext("2d", { willReadFrequently: true });

              ctx.imageSmoothingEnabled = true;
              ctx.imageSmoothingQuality = "high";
              ctx.drawImage(img, 0, 0, width, height);

              // Convert Canvas to Blob & Create Blob URL
              canvas.toBlob((blob) => {
                  if (blob) {
                      const blobURL = URL.createObjectURL(blob);
                      resolve(blobURL);
                  } else {
                      reject(new Error("Canvas.toBlob failed"));
                  }
              }, "image/jpeg", quality);
          };

          img.onerror = (err) => {console.log(err, 'check for the error')};
      };

      reader.onerror = () => reject(new Error("FileReader error"));
  });
}


const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      300,
      300,
      "jpg",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "blob"
    );
  });

export const getThumbnail = async (file) => {
  // Added check for firefox because Resizer.imageFileResizer is not working
  // for large images in firefox
  if (navigator.userAgent.search('Firefox')) {
    const image = await resizeImageToBlobURLViaCanvas(file);
    return image;
  } else {
    const image = await resizeFile(file);
    const src = URL.createObjectURL(image);
    return src;
  }
}

